import { Mapper } from "../../../../base/utils/mapper";
import { AttentionResponseModel } from "../../../../domain/models/consult/attention-response.model";
import { AtenttionResponseEntity } from "../entities/attention-response.entity";



export class AttentionImplementationRepositoryMapper extends Mapper<AtenttionResponseEntity, AttentionResponseModel> {
    mapFrom(param: AtenttionResponseEntity): AttentionResponseModel {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        };
    }
    mapTo(param: AttentionResponseModel): AtenttionResponseEntity {
        return {
            data:param.data,
            isSuccess:param.isSuccess,
            message:param.message,
            errors:param.errors
        }
    }
}